<template>
  <div class="cleaner-manage">
    <div class="page-operate-block">
      <span class="tit">保洁人员列表</span>
      <div>
        <el-button class="operate-btn" @click="addCleaner">新增</el-button>
      </div>
    </div>

    <div class="table-list-block">
      <r-table
        ref="tenantTable"
        :dataSource="cleanerList"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
      >
        >
        <el-table-column
          prop="name"
          label="姓名"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="phone"
          label="手机号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="staffTypeName"
          label="人员类型"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="certCode"
          label="身份证号码"
          show-overflow-tooltip
        ></el-table-column>
        <!-- <el-table-column
          prop="checkInTimes"
          label="负责房间"
          show-overflow-tooltip
        ></el-table-column> -->
        <el-table-column
          prop="createTime"
          label="登记时间"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="statusName"
          label="状态"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="operate"
          label="操作"
          show-overflow-tooltip
          width="300"
        >
          <template #default="scope">
            <el-button
              class="border-btn primary"
              size="small"
              @click="editCleaner(scope.row.id)"
              >编辑</el-button
            >
            <el-button
              class="border-btn warn"
              size="small"
              v-show="scope.row.status === 1"
              @click="checkCleanerStatus(scope.row.id, 2)"
              >禁用</el-button
            >
            <el-button
              class="border-btn primary"
              size="small"
              v-show="scope.row.status === 2"
              @click="checkCleanerStatus(scope.row.id, 1)"
              >启用</el-button
            >
            <el-button
              class="border-btn warn"
              size="small"
              @click="delCleaner(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </r-table>
    </div>
    <RModal
      :title="currentCleanerId ? '编辑保洁人员' : '新增保洁人员'"
      v-model="addCleanerModalShow"
      :closeOnClick="false"
      @change="addCleanerModalShow = false"
    >
      <template v-slot:content>
        <add-cleaner-modal
          v-if="addCleanerModalShow"
          :cleanerId="currentCleanerId"
          :storeId="storeId"
          @close="closeModal"
        ></add-cleaner-modal>
      </template>
    </RModal>
  </div>
</template>

<script>
import RModal from '@/components/common/RModal'
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
import addCleanerModal from './addCleanerModal'
import { mapActions } from "vuex";

export default {
  components: { RTable, RModal, addCleanerModal },
  mixins: [tableMix],
  data() {
    return {
      cleanerList: [],
      pagination: { total: 0, pageIndex: 1, pageSize: 20 },
      addCleanerModalShow: false,
      currentCleanerId: null,
      storeId: null
    }
  },
  created() {
    const currShopStr = localStorage.getItem('curShop'),
      currShop = currShopStr && JSON.parse(currShopStr);
    this.storeId = currShop?.id;
    this.getQuery();

    // 监听全局门店切换
    this.$eventBus.on('change-shop', store => {
      this.storeId = store.id;
      this.getQuery();
    })
  },

  beforeUnmount() {
    this.$eventBus.off('change-shop')
  },

  methods: {
    ...mapActions(["fetchData"]),

    // 获取保洁人员列表
    getQuery() {
      let url = 'CLEAN.CLEANER.GET_LIST'
      let params = { storeId: this.storeId, pageSize: this.pagination.pageSize, pageNumber: this.pagination.pageIndex }
      if (!params.storeId) delete params.storeId

      this.fetchData({
        url,
        method: 'get',
        params
      }).then(res => {
        this.cleanerList = res?.data || [];
        this.pagination.total = res?.count || 0
      })
    },

    // 新增保洁人员
    addCleaner() {
      this.currentCleanerId = null;
      this.addCleanerModalShow = true;
    },

    // 编辑保洁人员
    editCleaner(id) {
      this.currentCleanerId = id;
      this.addCleanerModalShow = true;
    },

    // 启用和禁用
    checkCleanerStatus(cleanerId, status) {
      if (!cleanerId) return;
      this.fetchData({
        url: 'CLEAN.CLEANER.POST_SAVE',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        params: { id: cleanerId, status }
      }).then(res => {
        if (res) {
          this.$message.success('操作成功')
          this.getQuery()
        } else {
          this.$message.error('操作失败')
        }
      }).catch(err => {
        this.$message.error('操作失败')
      })
    },

    // 删除
    delCleaner(cleanerId) {
      if (!cleanerId) return;
      this.$confirm('确定删除该保洁吗？', { type: 'warning' }).then(res => {
        if (res) {
          this.fetchData({
            url: 'CLEAN.CLEANER.DELETE',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            params: [cleanerId]
          }).then(res => {
            if (res) {
              this.$message.success('操作成功')
              this.getQuery()
            } else {
              this.$message.error('操作失败')
            }
          }).catch(err => {
            this.$message.error('操作失败')
          })
        }
      })
    },

    // 关闭新增编辑弹框
    closeModal($event) {
      this.addCleanerModalShow = false;
      if ($event === true) {
        this.getQuery();
      }
    },
  }
}
</script>